export const plural = (
  count: number,
  trans: { one: string; other: string }
): string => {
  if (count === 0) {
    return "";
  }

  if (count === 1) {
    return trans.one;
  }

  return trans.other;
};
